<template>
  <my-select ref="mySelectSearchRef" 
             show-search
             :default-active-first-option="false"
             :show-arrow="false"
             :filter-option="false"
             :not-found-content="null"
             :allowClear="false"
             :params="props.params"
             :searchValue="searchValue"
             @search="handleSearch"
             @change="handleChange"
             @focus="onFocus"
             @select="onSelect"
             :on-get-form-data="onGetFormData"
  >
    <slot></slot>
  </my-select>
</template>

<script setup>
  import { ref, defineExpose, defineProps, defineEmits, onMounted, watch, nextTick, useAttrs } from 'vue';
  import mySelect from './index.vue';

  const props = defineProps({
    url: {
      type: [Function],
    },
    params: {
      type: [Object],
      default: () => ({})
    },
    show: {
      type: [Boolean],
      default: true,
    },
    onGetFormData: {
      type: [Function],
    },
    // minimum number of characters required to trigger fetch in handleSearch
    minLength: {
      type: Number,
      default: 1
    },
    maxLength: {
      type: Number,
      default: 50
    }
  });
  const emits = defineEmits(['select']);

  const mySelectSearchRef = ref();
  const init = (...arg) => mySelectSearchRef.value.init(...arg);

  const attrs = useAttrs();

  let timeout;
  function fetch(str = '') {
    const value = str.slice(0, props.maxLength);
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
    timeout = setTimeout(() => {
      let params = JSON.parse(JSON.stringify(props.params));
      params[attrs.fieldNames?.label || 'label'] = value;
      mySelectSearchRef.value.init(props.url, params);
    }, 500);
  }

  /*
  watch(() => props.show, () => {
    nextTick(() => {
      let params = JSON.parse(JSON.stringify(props.params));
      params[attrs.fieldNames?.value || 'value'] = attrs.modelValue;
      mySelectSearchRef.value.init(props.url, params);
    });
  }, { immediate: true });
  */

  watch(() => attrs.modelValue, (value, old) => {
    if (!!value && !old && typeof props.onGetFormData == 'function') {
      const formData = props.onGetFormData();
      if (formData[attrs.fieldNames?.label || 'label']) {
        const options = [formData];
        nextTick(() => {
          mySelectSearchRef.value.setOption(options);
        });
      }
    }
  }, { immediate: true });

  const searchValue = ref('');
  watch(() => searchValue.value, value => {
    if (value) {
      searchValue.value = searchValue.value.slice(0, props.maxLength);
    }
  });
  const handleSearch = val => {
    //console.log(val, 'val');
    searchValue.value = val;
    // only fetch when value length is greater than or equal to minLength
    const length = (searchValue.value || '').length;
    if (props.minLength <= 0 || length >= props.minLength) {
      fetch(searchValue.value);
    } else {
      // if value is empty or too short, clear options
      if (!searchValue.value && searchValue.value !== 0) {
        mySelectSearchRef.value.setOption([]);
      }
    }
  };

  const onFocus = () => {
    if (!searchValue.value && typeof props.onGetFormData == 'function') {
      const formData = props.onGetFormData();
      searchValue.value = formData[attrs.fieldNames?.label || 'label'];
    }
  }

  const onSelect = (value, option) => {
    setTimeout(() => {
      searchValue.value = option[attrs.fieldNames?.label || 'label'];
    }, 300);
    emits('select', value, option);
  }

  const handleChange = val => {
    if (!val && val !== 0) {
      mySelectSearchRef.value.setOption([]);
    }
  };


  defineExpose({
    init
  });
</script>
